import { render } from "./PostContentText.vue?vue&type=template&id=7a949a82"
import script from "./PostContentText.vue?vue&type=script&lang=js"
export * from "./PostContentText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/PostContentText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a949a82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a949a82', __exports__)) {
    api.reload('7a949a82', __exports__)
  }
  
  module.hot.accept("./PostContentText.vue?vue&type=template&id=7a949a82", () => {
    api.rerender('7a949a82', render)
  })

}


export default __exports__